import { useEffect, useRef, type ReactNode } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import SobreMiSection from '@/pages/home/components/SobreMiSection';
import EditorialTransition from '@/pages/home/components/EditorialTransition';
import MomentoActual from '@/pages/home/components/MomentoActual';
import FinalCta from '@/pages/home/components/FinalCta';

function ScrollReveal({ children }: { children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );

    const elements = node.querySelectorAll('.reveal-on-scroll');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return <div ref={ref}>{children}</div>;
}

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <ScrollReveal>
          <SobreMiSection />
          <EditorialTransition />
          <MomentoActual />
          <FinalCta />
        </ScrollReveal>
      </main>
      <Footer />
    </>
  );
}